import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AUTHENTICATED_ENTRY } from "configs/AppConfig";
import { authStore } from "stores/auth.store";
import Loading from "components/shared-components/Loading";
import { adminStore } from "stores/admin.store";
import { getOnboardingPath } from "utils/onboarding";

const PublicRoute = () => {
  const { isAuthenticated } = authStore();
  const { userProfile, profileLoaded } = adminStore();

  if (!isAuthenticated) return <Outlet />;

  if (!profileLoaded) return <Loading cover="page" />;

  const target = userProfile?.isOnboarding
    ? getOnboardingPath(userProfile)
    : AUTHENTICATED_ENTRY;

  return <Navigate to={target} replace />;
};

export default PublicRoute;
